export enum ACCOUNT_SECTION {
  MY_CLOSET = 'myCloset',
  APPOINTMENTS = 'appointments',
  WISHLIST = 'wishlist',
  PAYMENT = 'payment',
  MEMBERSHIP = 'membership',
  ORDER_HISTORY = 'orderHistory',
  REWARDS = 'earnRewards',
  AMBASSADOR = 'ambassador',
  DOWNLOAD_APP = 'downloadApp',
  CONCIERGE = 'concierge'
}
